const CONFIGS = {
  GROUP_ICON_CLASS: 'accordion-editorial-amp',
  GROUP_TITLE_DEFAULT_PROPS: {
    color: 'neutral2',
    element: 'span',
    lineHeight: '40px',
    fontFamily: 'secondary',
    fontSize: '20px'
  }
}

export { CONFIGS }